<div class="about-summary">
  <div class="about-copy">
    <h3 class="about-heading">Mission</h3>
    <p>To protect authenticity, connect communities, and keep the underground spirit loud and honest. And to build a community that values culture over clout.</p>

    <h3 class="about-heading">Vision</h3>
    <p>To grow into the most trusted voice for Nigeria's rave and underground scene, keeping the culture pure, connected, and unapologetically alive.</p>

    <ng-container *ngIf="!condensed">
      <p>This community lives between the kick drum and the sunrise. Between the DJ's cue and the crowd's response. Between release and renewal.</p>
      <p>This space is for seekers. For house heads. For afro-tech futurists. For gqom soldiers. For deep house souls.</p>
      <p>You are part of the <span class="restless-highlight">RESTLESS</span>. A vital link in a growing network built on shared energy.</p>
      <p><span class="restless-highlight">Restless</span> Society is more than a page. It is a society where your <span class="restless-highlight">restlessness</span> finds its people.</p>
    </ng-container>
  </div>

  <a *ngIf="condensed" routerLink="/about" class="about-link">
    Read the full story
    <i class="bi bi-arrow-right"></i>
  </a>
</div>
